import { LegalPage } from "../../components/LegalPage";

export function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      description="WeConsult Rx privacy policy: what we collect, how we use it, our third parties, retention, and your rights under GDPR and CCPA."
      path="/privacy"
      effective="2026-05-30"
    >
      <p>
        This Privacy Policy describes how WeConsult Rx (“we”, “us”) collects,
        uses, and shares information in connection with{" "}
        <strong>weconsultrx.com</strong> and the WeConsult Rx platform.
      </p>

      <h2>Information we collect</h2>
      <h3>Account &amp; contact data</h3>
      <ul>
        <li>Name, work email, phone, organization, role.</li>
        <li>Demo / contact form submissions.</li>
        <li>Newsletter subscriptions.</li>
      </ul>

      <h3>Application usage data</h3>
      <ul>
        <li>Login events, audit log entries, feature usage.</li>
        <li>IP address, browser user agent, request timestamps.</li>
        <li>Performance and error telemetry (aggregated; no PHI).</li>
      </ul>

      <h3>Customer content</h3>
      <p>
        Customer content (including PHI) is processed only under a Business
        Associate Agreement (BAA). It is owned and controlled by the customer,
        not by WeConsult Rx. See our <a href="/baa">BAA</a>.
      </p>

      <h2>How we use information</h2>
      <ul>
        <li>To provide and improve the platform.</li>
        <li>To respond to demo / contact requests.</li>
        <li>To send transactional and (with consent) marketing email.</li>
        <li>To meet legal, regulatory, and HIPAA obligations.</li>
        <li>To investigate fraud, abuse, or security incidents.</li>
      </ul>

      <p>
        We do <strong>not</strong> sell personal information. We do not run
        third-party advertising trackers. We do not share customer content for
        AI training.
      </p>

      <h2>Subprocessors</h2>
      <p>
        See our <a href="/subprocessors">list of subprocessors</a>. We execute
        a BAA with every subprocessor that may touch PHI.
      </p>

      <h2>Retention</h2>
      <ul>
        <li>Account data: for the duration of the account + 90 days.</li>
        <li>Audit log: 7 years (HIPAA §164.530(j)).</li>
        <li>Customer content: per Master Services Agreement.</li>
        <li>Marketing leads: 18 months unless extended by ongoing dialogue.</li>
      </ul>

      <h2>Your rights</h2>
      <p>
        Depending on your jurisdiction, you may have the right to access,
        correct, delete, or port your personal information. See{" "}
        <a href="/gdpr">/gdpr</a> for EU/UK rights and{" "}
        <a href="/ccpa">/ccpa</a> for California rights.
      </p>
      <p>
        To exercise any right, email privacy@weconsultrx.com.
      </p>

      <h2>International transfers</h2>
      <p>
        Our infrastructure is primarily hosted in the United States. EU/UK
        transfers rely on Standard Contractual Clauses incorporated into our
        Data Processing Agreement.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We will post material changes here and update the effective date. For
        active customers we will additionally notify by email.
      </p>

      <h2>Contact</h2>
      <p>
        Data Protection Officer · privacy@weconsultrx.com
      </p>
    </LegalPage>
  );
}
